import React from 'react';
import { validations } from './validations';
import NodeWrapper from './NodeWrapper';
import { Grid } from '@material-ui/core';
import Delegate from './themes/classic/Delegate';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  label: {
    display: 'inline-block',
    textAlign: 'center'
  }
})


const ExternalFunction = (props) => {

  const iconStyle = {
    top: '32%',
    left: '32%',
  }

  const classes = useStyles();


  return (
    <Grid row>
      <Grid item xs={12}>
      <NodeWrapper {...props}>
        <Delegate props={props} validations={validations} iconStyle={iconStyle}/>
      </NodeWrapper>
      </Grid>
      
    </Grid>
  );
};

export default ExternalFunction;
